import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UiState {
  isSidebarOpen: boolean;
  isModalOpen: boolean;
  activeConfig: 'upload' | 'color' | 'size' | 'shape' | null;
  selectedObjectId: string | null;
  isLoading: boolean;
  loadingMessage: string;
}

const initialState: UiState = {
  isSidebarOpen: false,
  isModalOpen: false,
  activeConfig: null,
  selectedObjectId: null,
  isLoading: false,
  loadingMessage: '',
};

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.isSidebarOpen = action.payload;
    },
    setModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isModalOpen = action.payload;
    },
    setActiveConfig: (state, action: PayloadAction<UiState['activeConfig']>) => {
      state.activeConfig = action.payload;
    },
    setSelectedObjectId: (state, action: PayloadAction<string | null>) => {
      state.selectedObjectId = action.payload;
    },
    setLoading: (state, action: PayloadAction<{isLoading: boolean, message?: string}>) => {
      state.isLoading = action.payload.isLoading;
      state.loadingMessage = action.payload.message || '';
    },
    resetUiState: (state) => {
      state.isSidebarOpen = false;
      state.isModalOpen = false;
      state.activeConfig = null;
      state.selectedObjectId = null;
      state.isLoading = false;
      state.loadingMessage = '';
    }
  }
});

export const {
  setSidebarOpen,
  setModalOpen,
  setActiveConfig,
  setSelectedObjectId,
  setLoading,
  resetUiState
} = uiSlice.actions;

export default uiSlice.reducer;
